import { put } from 'redux-saga/effects';

import * as actions from '../actions';

import { get } from '../../utils/api';
import { handleError } from '../../utils/errors';

export default function* fetchUserPermissionsSaga(action) {
  try {
    const response = yield get(`/api/v1/user/permissions?account_id=${action.accountId}`, false);
    yield put(actions.fetchUserPermissionsSuccess(response.data));
  } catch (error) {
    yield handleError(error);
    yield put(actions.fetchUserPermissionsFail(error));
  }
}



// WEBPACK FOOTER //
// ./app/javascript/app/store/sagas/entitlements.js